import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"




const AssetReturn = (id,asset, return_date,) => {
  return axios.post(API + "contracts/asset-return/"+id+"/", {
   asset,
   return_date
  },{headers: authHeader(),});
};
const AddAssetRetrunService = {
    AssetReturn
};
export default AddAssetRetrunService;